import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HioUserinfoService, UserInfo } from './../hio-userinfo.service';
import { RouterLink } from '@angular/router';
import { JcRaisedButtonDirective } from '@jc/button';
import { JcIconButtonDirective } from '@jc/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@Component({
    selector: 'hio-userinfo-entry',
    templateUrl: './hio-userinfo-entry.component.html',
    styleUrls: ['./hio-userinfo-entry.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FontAwesomeModule, JcIconButtonDirective, JcRaisedButtonDirective, RouterLink]
})
export class HioUserinfoEntryComponent implements OnInit {
  @Input() info: UserInfo;

  constructor(public userInfo: HioUserinfoService) { }

  ngOnInit() {

  }

  animation() {
    return this.info.iconRotate ? 'spin' : '';
  }

}
